import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Register from "./components/Register";
import UserHome from "./components/UserHome";
import UserProfile from "./components/UserProfile";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <ProtectedRoute
            path="/user/:id/home"
            component={UserHome}
            render={(props) => <UserHome {...props} component={UserHome} />}
          />
          <ProtectedRoute
            path="/user/:id/profile"
            component={UserProfile}
            render={(props) => (
              <UserProfile {...props} component={UserProfile} />
            )}
          />
        </Switch>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
